/**
 *  <Desription of Service here>
 *
 * @export
 * @class TrackingManager
 */
export class TrackingManager {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', 'AngularServices', 'DataManager', 'ProgressManager'];
  public Uatu:any
  public genderIsSet:boolean = false;
  public poseIsSet:boolean = false;
  public heroGender: any;
  public heroPose: any;
  // public userActivity: any = [];

  /**
   * @param {$log} $log - Angular logging Service.
   */
  constructor(public $log: any, public AngularServices: any, public DataManager: any, public ProgressManager: any) {
    this.$log = $log.getInstance('TrackingManager', false);
    this.$log.debug('constructor');
    this.Uatu = this.AngularServices.$window.Uatu
  }

  /*public trackActivity(userEvent): void{
    this.userActivity.push(userEvent);
    console.log('tracking ', this.userActivity);
  }*/

  public trackStart(): void{
    if (this.DataManager.config.settings.isAnalyticsEnabled){
      let screenIndex: any = this.ProgressManager.getScreenIndex()
      let returningVisitor;
      if (screenIndex > 0) {
        returningVisitor = true
      } else {
        returningVisitor = false
      }
      // console.log({game_name: 'Spider-Man | Create Your Own Web-Warrior', cyo_has_existing: returningVisitor})
      if (this.Uatu){
        this.Uatu.warn("cyo_start",
          {game_name: 'Spider-Man | Create Your Own Web-Warrior', cyo_has_existing: returningVisitor}
        );
      }
    }
  }

  public trackGender(gender): void{
    // console.log({game_name: 'Spider-Man | Create Your Own Web-Warrior', cyo_gender: gender})
    if (this.DataManager.config.settings.isAnalyticsEnabled){
      if (this.Uatu){
        this.Uatu.warn("cyo_gender_selection",
        {game_name: 'Spider-Man | Create Your Own Web-Warrior', cyo_gender: gender, cyo_pose: this.ProgressManager.getPose()}
        );
      }
    }
  }

  public trackPose(pose): void{
    // console.log({game_name: 'Spider-Man | Create Your Own Web-Warrior', cyo_pose: pose, cyo_gender: this.ProgressManager.getGender()})
    if (this.DataManager.config.settings.isAnalyticsEnabled){
      if (this.Uatu){
        this.Uatu.warn("cyo_pose_selection",
        {game_name: 'Spider-Man | Create Your Own Web-Warrior', cyo_pose: pose, cyo_gender: this.ProgressManager.getGender()}
        );
      }
    }
  }

  public trackCustome(gender, pose, costume, section): void{
    if (this.DataManager.config.settings.isAnalyticsEnabled){
      if (this.Uatu){
        this.Uatu.warn("cyo_costume_selection",
        {game_name: 'Spider-Man | Create Your Own Web-Warrior', cyo_gender: gender, cyo_pose: pose, cyo_costume: costume, cyo_section: section}
        );
      }
    }
  }

  public trackTool(tool): void{
    //alert('cyo_tool ' + tool)
    if (this.DataManager.config.settings.isAnalyticsEnabled){
      if (this.Uatu){
        this.Uatu.warn("cyo_tool",
        {game_name: 'Spider-Man | Create Your Own Web-Warrior', cyo_tool: tool}
        );
      }
    }
  }

  public trackStickers(stickers): void{
    //console.log({game_name: 'Spider-Man | Create Your Own Web-Warrior', cyo_sticker: stickers.toString()})
    if (this.DataManager.config.settings.isAnalyticsEnabled){
      if (this.Uatu){
        this.Uatu.warn("cyo_stickers",
        {game_name: 'Spider-Man | Create Your Own Web-Warrior', cyo_sticker: stickers.toString()}
        );
      }
    }
  }

  public trackBackground(background): void{
    //alert('cyo_backgrounds ' + background)
    if (this.DataManager.config.settings.isAnalyticsEnabled){
      if (this.Uatu){
        this.Uatu.warn("cyo_backgrounds",
        {game_name: 'Spider-Man | Create Your Own Web-Warrior', cyo_background: background}
        );
      }
    }
  }

  public trackDownload(): void{
    //console.log('cyo_downloads')
    if (this.DataManager.config.settings.isAnalyticsEnabled){
      if (this.Uatu){
        this.Uatu.warn("cyo_downloads",
        {game_name: 'Spider-Man | Create Your Own Web-Warrior'}
        );
      }
    }
  }

  public trackShares(): void{
    //console.log('cyo_shares')
    if (this.DataManager.config.settings.isAnalyticsEnabled){
      if (this.Uatu){
        this.Uatu.warn("cyo_shares",
        {game_name: 'Spider-Man | Create Your Own Web-Warrior'}
        );
      }
    }
  }

  public trackRestart(): void{
    //alert('cyo_restart')
    if (this.DataManager.config.settings.isAnalyticsEnabled){
      if (this.Uatu){
        this.Uatu.warn("cyo_restart",
        {game_name: 'Spider-Man | Create Your Own Web-Warrior'}
        );
      }
    }
  }

}



/** WEBPACK FOOTER **
 ** ./src/common/services/tracking-manager/tracking-manager.ts
 **/